module.exports = __webpack_public_path__ + "img/google-music.ec718052.png";